<template>
  <Title-card :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="form-table-wrap">
        <Form
          ref="form"
          layoutType="grid"
          :optionList="formRow"
          :defaultModel="defaultValue"
        ></Form>
        <div class="operation-wrap">
          <a-button @click="clearAll">清空条件</a-button>
          <a-button @click="toSearch">搜索</a-button>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initTableValue"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </Title-card>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import AModal from '../../components/AModal'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
// import makeFakerData from '@/mixins/makeFakerData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import TitleCard from '../../../../components/common/TitleCard.vue'
import { getCollectList, deleteCollectList } from '@/api/favority.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      customOtherOpt: {
        pagination: {
          pageSize: 10,
          pageNum: 1,
          total: 0
        }
      },
      defaultSearchParam: { searchValue: '0' }, // 默认筛选条件
      defaultValue: {
        searchValue: '0'
      },
      tableValue: [],
      utilsBtnList: [{ name: '删除', cb: 'batchDelete' }]
    }
  },
  components: {
    Table,
    Form,
    AModal,
    TitleCard,
    TableToolsWrap
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
  },
  methods: {
    async initTableValue() {
      try {
        this.loadingTable(true)
        const params = this.handlerBeforeRequestParams()
        const { data } = await getCollectList(params)
        const { rows, total } = data
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.tableValue = this.handlerDateFormat(rows)
        this.customOtherOpt.pagination.total = total
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loadingTable(false)
      }
    },
    // 请求前的参数收集
    handlerBeforeRequestParams() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        ...this.searchParam,
        pageNum,
        pageSize
      }
      return params
    },
    delete(row) {
      this.customModalOpt.contentTips = '是否确定取消收藏'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteCollectList(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    toDetail(instance) {
      const { scope } = instance
      this.$router.push({ name: 'detailDeal', query: { id: scope.id } })
    },
    // 批量删除
    batchDelete() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const idstatus = selectedIds.map(item => item.id)
      this.customModalOpt.contentTips = '是否确定删除已选的综合信息'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的综合信息')
      }
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: idstatus }
      })
    }
  }
}
</script>
